import { createSlice, createSelector } from "@reduxjs/toolkit";

const initialState = {
  value: "",
  participantName: null,
  searchWasMade: false,
  page: 1,
  size: 10,
};

const sendersSearchSlice = createSlice({
  name: "sendersSearch",
  initialState,
  reducers: {
    setValue: (state, action) => {
      state.value = action.payload ?? "";
    },
    commitCriteria: (state, action) => {
      const { participantName } = action.payload || {};
      state.participantName = participantName ?? null;
      state.searchWasMade = true;
      state.page = 1;
    },
    setPagination: (state, action) => {
      const { page, size } = action.payload || {};
      if (page !== undefined) state.page = page;
      if (size !== undefined) state.size = size;
    },
    clearSearchParameters: () => ({ ...initialState }),
  },
});

export const {
  setValue,
  commitCriteria,
  setPagination,
  clearSearchParameters,
} = sendersSearchSlice.actions;

export const selectSendersSearch = (state) => state.sendersSearch;

const isFilled = (v) => (typeof v === "string" ? v.trim() !== "" : v != null);

export const selectHasCriteria = createSelector([selectSendersSearch], (s) =>
  isFilled(s.participantName)
);

export default sendersSearchSlice.reducer;
